import { Instance } from "@gadgetinc/mobx-quick-tree";
import { createContext, useContext } from "react";
import type { InteractionPreferences } from "./InteractionPreferences";

export const InteractionPreferencesContext = createContext<Instance<typeof InteractionPreferences>>(null as any);
export const useInteractionPreferences = () => useContext(InteractionPreferencesContext);
